import { gql, useApolloClient, useMutation, useQuery } from '@apollo/client';

const GET_APPLICATIONS = gql`
   query GetApplicationsByStatus(
      $status: String
      $currentStage: String
      $approvedByTechnicalStaff: Boolean
      $acceptedByTechnicalStaff: Boolean
      $assignedTechnicalStaffId: ID
      $unassignedOnly: Boolean
      $requestType: String

      $acceptedByReceivingClerk: Boolean
      $recordedByReceivingClerk: Boolean

      $acceptedByPENRCENROfficer: Boolean
      $approvedByPENRCENROfficer: Boolean

      $reviewedByChief: Boolean

      $awaitingOOP: Boolean
      $OOPCreated: Boolean

      #  $hasInspectionReport: Boolean
      $InspectionReportsReviewedByChief: Boolean
      $InspectionReportsReviewedByPENRCENROfficer: Boolean

      $awaitingPermitCreation: Boolean
      $PermitCreated: Boolean

      $ApprovedInventoryRequest: Boolean

      $certificateSignedByForestRanger: Boolean
      $certificateSignedByChiefTSD: Boolean
      $certificateSignedByPENRCENROfficer: Boolean
   ) {
      getApplicationsByStatus(
         status: $status
         currentStage: $currentStage
         approvedByTechnicalStaff: $approvedByTechnicalStaff
         acceptedByTechnicalStaff: $acceptedByTechnicalStaff
         assignedTechnicalStaffId: $assignedTechnicalStaffId
         unassignedOnly: $unassignedOnly
         requestType: $requestType

         acceptedByReceivingClerk: $acceptedByReceivingClerk
         recordedByReceivingClerk: $recordedByReceivingClerk

         acceptedByPENRCENROfficer: $acceptedByPENRCENROfficer
         approvedByPENRCENROfficer: $approvedByPENRCENROfficer

         reviewedByChief: $reviewedByChief

         awaitingOOP: $awaitingOOP
         OOPCreated: $OOPCreated

         # hasInspectionReport: $hasInspectionReport
         InspectionReportsReviewedByChief: $InspectionReportsReviewedByChief
         InspectionReportsReviewedByPENRCENROfficer: $InspectionReportsReviewedByPENRCENROfficer

         awaitingPermitCreation: $awaitingPermitCreation
         PermitCreated: $PermitCreated

         ApprovedInventoryRequest: $ApprovedInventoryRequest

         certificateSignedByForestRanger: $certificateSignedByForestRanger
         certificateSignedByChiefTSD: $certificateSignedByChiefTSD
         certificateSignedByPENRCENROfficer: $certificateSignedByPENRCENROfficer
      ) {
         id
         currentStage
         status
         reviewedByChief
         InspectionReportsReviewedByChief
         awaitingOOP
         OOPCreated
         awaitingPermitCreation
         PermitCreated
         assignedTechnicalStaffId
         ... on CSAWPermit {
            id
            applicationNumber
            applicationType
            requestType
            status
            currentStage
            dateOfSubmission
            assignedTechnicalStaffId
            assignedTechnicalStaffName
            assignmentDate
            history {
               stage
               status
               timestamp
               notes
               actionBy
            }
         }
         ... on COVPermit {
            id
            applicationNumber
            applicationType
            requestType
            status
            currentStage
            dateOfSubmission
            assignedTechnicalStaffId
            assignedTechnicalStaffName
            assignmentDate
            history {
               stage
               status
               timestamp
               notes
               actionBy
            }
         }
         ... on PTPRPermit {
            id
            applicationNumber
            applicationType
            requestType
            status
            currentStage
            dateOfSubmission
            assignedTechnicalStaffId
            assignedTechnicalStaffName
            assignmentDate
            history {
               stage
               status
               timestamp
               notes
               actionBy
            }
         }
         ... on PLTCPPermit {
            id
            applicationNumber
            applicationType
            requestType
            status
            currentStage
            dateOfSubmission
            assignedTechnicalStaffId
            assignedTechnicalStaffName
            assignmentDate
            history {
               stage
               status
               timestamp
               notes
               actionBy
            }
         }
         ... on PLTPPermit {
            id
            applicationNumber
            applicationType
            requestType
            status
            currentStage
            dateOfSubmission
            assignedTechnicalStaffId
            assignedTechnicalStaffName
            assignmentDate
            history {
               stage
               status
               timestamp
               notes
               actionBy
            }
         }
         ... on TCEBPPermit {
            id
            applicationNumber
            applicationType
            requestType
            status
            currentStage
            dateOfSubmission
            assignedTechnicalStaffId
            assignedTechnicalStaffName
            assignmentDate
            isRequestForCutting
            isRequestForEarthBalling
            history {
               stage
               status
               timestamp
               notes
               actionBy
            }
         }
      }
   }
   `;

const UNDO_APPROVAL = gql`
   mutation UndoApproval($id: ID!) {
      undoApproval(id: $id) {
         id
         status
         currentStage
      }
   }
   `;

export const useApplications = (params = {}) => {
   const client = useApolloClient();
   const { data, loading, error, refetch } = useQuery(GET_APPLICATIONS, {
      variables: params,
      fetchPolicy: 'network-only'
   });

   return {
      applications: data?.getApplicationsByStatus || [],
      loading,
      error,
      refetch
   };
};

export const useUndoApplicationApproval = () => {
   const [undoApproval] = useMutation(UNDO_APPROVAL);

   const handleUndoApproval = async (id) => {
      try {
         const { data } = await undoApproval({
            variables: { id }
         });
         return data.undoApproval;
      } catch (error) {
         console.error('Error undoing approval:', error);
         throw error;
      }
   };

   return { handleUndoApproval };
};
